__turbopack_context__.v({
  "colHighlight": "plans-module__yh6-Ma__colHighlight",
  "ctaRow": "plans-module__yh6-Ma__ctaRow",
  "feature": "plans-module__yh6-Ma__feature",
  "featureList": "plans-module__yh6-Ma__featureList",
  "footnote": "plans-module__yh6-Ma__footnote",
  "groupRow": "plans-module__yh6-Ma__groupRow",
  "no": "plans-module__yh6-Ma__no",
  "plan": "plans-module__yh6-Ma__plan",
  "planBody": "plans-module__yh6-Ma__planBody",
  "planCta": "plans-module__yh6-Ma__planCta",
  "planHighlighted": "plans-module__yh6-Ma__planHighlighted",
  "planItem": "plans-module__yh6-Ma__planItem",
  "planName": "plans-module__yh6-Ma__planName",
  "planSlot": "plans-module__yh6-Ma__planSlot",
  "planSummary": "plans-module__yh6-Ma__planSummary",
  "planTop": "plans-module__yh6-Ma__planTop",
  "plans": "plans-module__yh6-Ma__plans",
  "plans4": "plans-module__yh6-Ma__plans4",
  "price": "plans-module__yh6-Ma__price",
  "priceFrom": "plans-module__yh6-Ma__priceFrom",
  "priceNote": "plans-module__yh6-Ma__priceNote",
  "pricing": "plans-module__yh6-Ma__pricing",
  "pricingCards": "plans-module__yh6-Ma__pricingCards",
  "pricingFull": "plans-module__yh6-Ma__pricingFull",
  "pricingHeading": "plans-module__yh6-Ma__pricingHeading",
  "table": "plans-module__yh6-Ma__table",
  "tableWrap": "plans-module__yh6-Ma__tableWrap",
  "thFeature": "plans-module__yh6-Ma__thFeature",
  "thFeatured": "plans-module__yh6-Ma__thFeatured",
  "thName": "plans-module__yh6-Ma__thName",
  "thPlan": "plans-module__yh6-Ma__thPlan",
  "thPrice": "plans-module__yh6-Ma__thPrice",
  "tiers": "plans-module__yh6-Ma__tiers",
  "value": "plans-module__yh6-Ma__value",
  "yes": "plans-module__yh6-Ma__yes",
});
